// extracted by mini-css-extract-plugin
export default {"placementsBlock":"SponsoredBrandsPlacementsTable_placementsBlock__yU97S","actions":"SponsoredBrandsPlacementsTable_actions__ydHXM"};